<div class="analytics-portlet-Img100p display-radio-carousel-height {{ sectionclass }}" style="position: relative">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary u-color-white-900 c-portlet_box_specs"
	>
		<!-- this below span is for ltr2 where we need header in no data scenariio -->
		<span *ngIf="!hasData" class="header"></span>
		<div
			*ngIf="hasData"
			class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom"
			style="position: relative"
		>
			<div class="o-stack__cell portlet-subheader-wrapper">
				<div class="r8-creatives-heading" style="display: none">Audio Creative Performance</div>
				<h5 class="portlet-subheader r8-portlet-subheader">{{ setDisplayProperties.name }}</h5>
				<h5 *ngIf="isR104" class="portlet-subheader r8-portlet-subheader r104-creatives">
					{{ setDisplayProperties.name }}
				</h5>
				<h6 class="portlet-subheader r104-creatives" *ngIf="isR104 && displayData && displayData.length > 0">
					{{ count }} | {{ displayData.length }}
				</h6>
				<h6 class="portlet-subheader" *ngIf="displayData && displayData.length > 0">
					{{ count }} of {{ displayData.length }} Streaming Audio creatives in selected date range
				</h6>
				<h6
					class="portlet-subheader r8-portlet-subheader"
					*ngIf="displayData && displayData.length > 0"
					style="display: none"
				>
					{{ count }} of {{ displayData.length }} creatives
				</h6>
				<h6
					class="portlet-subheader1"
					style="font-size: 1.1em; display: none"
					*ngIf="displayData && displayData.length > 0"
				>
					{{ count }} | {{ displayData.length }}
				</h6>
				<h6 *ngIf="setDisplayProperties.audioURL == ''" class="portlet-subheader">No Data to Display</h6>
				<a
					href="#"
					class="datatable_download_icon"
					*ngIf="downloadConfiguration && downloadConfiguration.enableDownload"
					(click)="downloadDataInCSV($event)"
					target="_blank"
				>
					<i class="fa fa-download" aria-hidden="true"></i>
				</a>
			</div>
			<div class="o-stack__cell">
				<div class="o-stack u-font-small">
					<div class="o-stack__cell u-relative" *ngIf="setDisplayProperties.audioURL !== '' && carouselItemsLength > 1">
						<a class="c-icon u-color-minor u-opacity-50p">
							<span class="next" (click)="nextArrow()" class="carousel-arrow-style">
								<i class="fa fa-angle-left" aria-hidden="true"></i>
							</span>
						</a>
						<a class="c-icon u-color-minor u-opacity-50p" style="margin-left: 5px">
							<span class="prev" (click)="prevArrow()" class="carousel-arrow-style">
								<i class="fa fa-angle-right" aria-hidden="true"></i>
							</span>
						</a>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="!isR8" class="c-portlet__content u-pt-small">
			<div class="audioDisplayblock" id="audioDisplayblock" *ngIf="!showLoad && hasData">
				<div class="audio-container card-long-img">
					<div class="audio-icon-block" *ngIf="setDisplayProperties?.audioURL !== ''; else noAudioCreative">
						<svg
							width="120px"
							height="79px"
							viewBox="0 0 120 79"
							version="1.1"
							xmlns="http://www.w3.org/2000/svg"
							xmlns:xlink="http://www.w3.org/1999/xlink"
						>
							<g id="V2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
								<path
									d="M60,0.5 C83.7685418,0.5 103.297788,19.2975778 105.742218,43.3890579 C113.886547,45.1109142 120,52.3415204 120,61 C120,70.9411255 111.941125,79 102,79 L102,79 L102,48.5 C102,24.1800725 83.1755828,4.5 60,4.5 C37.056173,4.5 18.3769235,23.7884391 18.0056329,47.7718092 L18,48.5 L18,79 C8.0588745,79 -3.55271368e-15,70.9411255 0,61 C0,52.3415204 6.11345265,45.1109142 14.2593319,43.3892075 C16.7022009,19.2975889 36.2314511,0.5 60,0.5 Z M63,45 L63,76 L61,76 L61,45 L63,45 Z M39,48 L39,73 L37,73 L37,48 L39,48 Z M75,49 L75,72 L73,72 L73,49 L75,49 Z M51,51 L51,70 L49,70 L49,51 L51,51 Z M67,52 L67,69 L65,69 L65,52 L67,52 Z M59,52 L59,69 L57,69 L57,52 L59,52 Z M35,52 L35,69 L33,69 L33,52 L35,52 Z M83,52 L83,69 L81,69 L81,52 L83,52 Z M47,53 L47,68 L45,68 L45,53 L47,53 Z M79,53 L79,68 L77,68 L77,53 L79,53 Z M27,54 L27,67 L25,67 L25,54 L27,54 Z M87,54 L87,67 L85,67 L85,54 L87,54 Z M71,55 L71,66 L69,66 L69,55 L71,55 Z M55,55 L55,66 L53,66 L53,55 L55,55 Z M43,56 L43,65 L41,65 L41,56 L43,56 Z M91,56 L91,65 L89,65 L89,56 L91,56 Z M31,56 L31,65 L29,65 L29,56 L31,56 Z M99,57 L99,64 L97,64 L97,57 L99,57 Z M23,58 L23,63 L21,63 L21,58 L23,58 Z M95,59 L95,62 L93,62 L93,59 L95,59 Z"
									id="Combined-Shape"
									fill="grey"
									class="primary-svg-fill"
								></path>
							</g>
						</svg>
						<!-- this below svg is for R101 which is bydefault display none -->
						<svg style="display: none" viewBox="0 0 120 77" xmlns="http://www.w3.org/2000/svg">
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M31.6898 11.3484C36.1372 5.03371 43.3899 0 54.5 0C75.0002 0 83.5234 12.9833 85.6203 21.0318C93.7493 21.3505 101.878 24.0525 108.142 28.7072C114.848 33.6898 119.5 40.9911 119.5 50C119.5 57.5419 117.682 64.1593 113.876 68.9341C110.021 73.771 104.294 76.5 97 76.5H19.5C17.2748 76.5 12.452 75.3314 8.16437 71.7924C3.76505 68.1613 0 62.0949 0 52.5C0 43.4451 2.88075 37.1536 8.04291 33.2074C12.6754 29.6661 18.8576 28.2422 25.6316 28.0289C26.113 23.1964 27.8389 16.8162 31.6898 11.3484ZM65.5 30C64.6719 30 64 30.6716 64 31.5V61.5C64 62.3284 64.6719 63 65.5 63C66.3281 63 67 62.3284 67 61.5V31.5C67 30.6716 66.3281 30 65.5 30ZM46 35.5C46 34.6716 46.6719 34 47.5 34C48.3281 34 49 34.6716 49 35.5V57.5C49 58.3284 48.3281 59 47.5 59C46.6719 59 46 58.3284 46 57.5V35.5ZM41.5 39C40.6719 39 40 39.6716 40 40.5V52.5C40 53.3284 40.6719 54 41.5 54C42.3281 54 43 53.3284 43 52.5V40.5C43 39.6716 42.3281 39 41.5 39ZM53.5 40C52.6719 40 52 40.6716 52 41.5V51.5C52 52.3284 52.6719 53 53.5 53C54.3281 53 55 52.3284 55 51.5V41.5C55 40.6716 54.3281 40 53.5 40ZM59.5 37C58.6719 37 58 37.6716 58 38.5V54.5C58 55.3284 58.6719 56 59.5 56C60.3281 56 61 55.3284 61 54.5V38.5C61 37.6716 60.3281 37 59.5 37ZM70 37.5C70 36.6716 70.6719 36 71.5 36C72.3281 36 73 36.6716 73 37.5V55.5C73 56.3284 72.3281 57 71.5 57C70.6719 57 70 56.3284 70 55.5V37.5ZM76 40.5C76 39.6716 76.6719 39 77.5 39C78.3281 39 79 39.6716 79 40.5V52.5C79 53.3284 78.3281 54 77.5 54C76.6719 54 76 53.3284 76 52.5V40.5Z"
								fill="#19237D"
								class="primary-svg-fill"
							/>
						</svg>
						<svg
							class="ltr7-radio-icon"
							style="display: none"
							width="111"
							height="99"
							viewBox="0 0 111 99"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M55.5 11.3438C30.59 11.3438 10.4062 31.5275 10.4062 56.4375V78.9844C10.4062 81.8678 8.08652 84.1875 5.20312 84.1875C2.31973 84.1875 0 81.8678 0 78.9844V56.4375C0 25.7824 24.8449 0.9375 55.5 0.9375C86.1551 0.9375 111 25.7824 111 56.4375V78.9844C111 81.8678 108.68 84.1875 105.797 84.1875C102.913 84.1875 100.594 81.8678 100.594 78.9844V56.4375C100.594 31.5275 80.41 11.3438 55.5 11.3438ZM17.3438 70.3125C17.3438 62.6596 23.5658 56.4375 31.2188 56.4375H34.6875C38.5248 56.4375 41.625 59.5377 41.625 63.375V91.125C41.625 94.9623 38.5248 98.0625 34.6875 98.0625H31.2188C23.5658 98.0625 17.3438 91.8404 17.3438 84.1875V70.3125ZM79.7812 56.4375C87.4342 56.4375 93.6562 62.6596 93.6562 70.3125V84.1875C93.6562 91.8404 87.4342 98.0625 79.7812 98.0625H76.3125C72.4752 98.0625 69.375 94.9623 69.375 91.125V63.375C69.375 59.5377 72.4752 56.4375 76.3125 56.4375H79.7812Z"
								fill="#25475B"
								class="primary-svg-fill"
							/>
						</svg>

						<div class="audio-file-block">
							<audio
								#audioTag
								id="preRollvideo"
								class="audioCreative"
								[src]="setDisplayProperties?.audioURL"
								[controls]="'controls'"
								[controlsList]="'nodownload'"
							></audio>
						</div>
					</div>
					<ng-template #noAudioCreative>
						<div class="icon-block no-audio-creative">NO DATA AVAILABLE</div>
					</ng-template>
				</div>
			</div>

			<div class="labels-position" [hidden]="showLoad">
				<div class="table-header_label metrics-labels" *ngIf="displayData && displayData.length > 0 && hasData">
					<table class="radio_creative_bottom_section">
						<tr>
							<td>
								<div class="radio-creative-table_svg_content">
									<div
										(click)="circleAudioClickEvent(0)"
										[ngStyle]="{ 'background-color': defaultColor, color: primaryColor, opacity: '1.0' }"
										class="drawCircle"
										id="svg_0Percent"
									></div>
									<div class="verticalLine"></div>
									<span id="percent0" class="radio-creative-footer-content">Started</span>
									<span
										class="radio-creative-footer-content percent-value"
										*ngIf="setDisplayProperties.percent_value_25 != null"
									>
										<span class="rate-label-first">100%</span>
									</span>
								</div>
								<div class="radio-creative-table_svg_content">
									<div
										(click)="circleAudioClickEvent(25)"
										[ngStyle]="{ 'background-color': defaultColor, color: primaryColor, opacity: '1.0' }"
										class="drawCircle"
										id="svg_25Percent"
									></div>
									<div class="verticalLine"></div>
									<span id="percent25" class="radio-creative-footer-content">25% Complete</span>
									<span
										class="radio-creative-footer-content percent-value"
										*ngIf="setDisplayProperties.percent_value_25 != null"
									>
										<span>{{ setDisplayProperties.percent_rate_25 }}%</span>
										<span class="views-label">{{ setDisplayProperties.percent_value_25 | formatNumber }} Views</span>
									</span>
								</div>
								<div class="radio-creative-table_svg_content">
									<div
										(click)="circleAudioClickEvent(50)"
										[ngStyle]="{ 'background-color': defaultColor, color: primaryColor, opacity: '1.0' }"
										class="drawCircle"
										id="svg_50Percent"
									></div>
									<div class="verticalLine"></div>
									<span id="percent50" class="radio-creative-footer-content">50% Complete</span>
									<span
										class="radio-creative-footer-content percent-value"
										*ngIf="setDisplayProperties.percent_value_50 != null"
									>
										<span>{{ setDisplayProperties.percent_rate_50 }}%</span>
										<span class="views-label">{{ setDisplayProperties.percent_value_50 | formatNumber }} Views</span>
									</span>
								</div>
								<div class="radio-creative-table_svg_content">
									<div
										(click)="circleAudioClickEvent(75)"
										[ngStyle]="{ 'background-color': defaultColor, color: primaryColor, opacity: '1.0' }"
										class="drawCircle"
										id="svg_75Percent"
									></div>
									<div class="verticalLine"></div>
									<span id="percent75" class="radio-creative-footer-content">75% Complete</span>
									<span
										class="radio-creative-footer-content percent-value"
										*ngIf="setDisplayProperties.percent_value_75 != null"
									>
										<span>{{ setDisplayProperties.percent_rate_75 }}%</span>
										<span class="views-label">{{ setDisplayProperties.percent_value_75 | formatNumber }} Views</span>
									</span>
								</div>
								<div class="radio-creative-table_svg_content">
									<div
										(click)="circleAudioClickEvent(100)"
										[ngStyle]="{ 'background-color': defaultColor, color: primaryColor, opacity: '1.0' }"
										class="drawCircle"
										id="svg_100Percent"
									></div>
									<span id="percent100" class="radio-creative-footer-content" style="margin-left: 1em"
										>100% Complete</span
									>
									<span
										class="radio-creative-footer-content percent-value"
										*ngIf="setDisplayProperties.percent_value_100 != null"
									>
										<span class="rate-label">{{ setDisplayProperties.percent_rate_100 }}%</span>
										<span class="views-label">{{ setDisplayProperties.percent_value_100 | formatNumber }} Views</span>
									</span>
								</div>
							</td>
							<td>
								<div>
									<table class="radio-creative-table">
										<tr>
											<td>
												<span class="table-header_label">Impressions</span>
											</td>
										</tr>
										<tr>
											<td>
												<span
													class="radio-creative-values-footer-content"
													*ngIf="setDisplayProperties.impressions != null"
													>{{ setDisplayProperties.impressions | formatNumber }}</span
												>
											</td>
										</tr>
									</table>
								</div>
								<div>
									<table class="radio-creative-table">
										<tr>
											<td>
												<span class="table-header_label">Completions</span>
											</td>
										</tr>
										<tr>
											<td>
												<span
													class="radio-creative-values-footer-content"
													*ngIf="setDisplayProperties.percent_value_100 != null"
													>{{ setDisplayProperties.percent_value_100 | formatNumber }}</span
												>
											</td>
										</tr>
									</table>
								</div>
								<div>
									<table class="radio-creative-table">
										<tr>
											<td>
												<span class="table-header_label">Completion Rate</span>
											</td>
										</tr>
										<tr>
											<td>
												<span
													class="radio-creative-values-footer-content"
													*ngIf="setDisplayProperties.percent_rate_100 != null"
													>{{ setDisplayProperties.completion_rate }}%</span
												>
											</td>
										</tr>
									</table>
								</div>
							</td>
						</tr>
					</table>
				</div>
				<div *ngIf="!hasData">
					<div class="no-data-container ctv-no-data">
						<div class="no-data-header">
							<h5>Creatives</h5>
						</div>
						<div class="map-no-data">No Data to Display</div>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="isR8" class="c-portlet__content u-pt-small">
			<div class="labels-position above-data" [hidden]="showLoad">
				<div class="table-header_label metrics-labels" *ngIf="displayData && displayData.length > 0 && hasData">
					<table class="radio_creative_bottom_section">
						<tr>
							<td>
								<div>
									<table class="radio-creative-table">
										<tr>
											<td>
												<span
													class="radio-creative-values-footer-content"
													*ngIf="setDisplayProperties.impressions != null"
													>{{ setDisplayProperties.impressions | formatNumber }}</span
												>
											</td>
										</tr>
										<tr>
											<td>
												<span class="table-header_label">Impressions</span>
											</td>
										</tr>
									</table>
								</div>
								<div>
									<table class="radio-creative-table">
										<tr>
											<td>
												<span
													class="radio-creative-values-footer-content"
													*ngIf="setDisplayProperties.percent_value_100 != null"
													>{{ setDisplayProperties.percent_value_100 | formatNumber }}</span
												>
											</td>
										</tr>
										<tr>
											<td>
												<span class="table-header_label">Completions</span>
											</td>
										</tr>
									</table>
								</div>
								<div>
									<table class="radio-creative-table">
										<tr>
											<td>
												<span
													class="radio-creative-values-footer-content"
													*ngIf="setDisplayProperties.percent_rate_100 != null"
													>{{ setDisplayProperties.completion_rate }}%</span
												>
											</td>
										</tr>
										<tr>
											<td>
												<span class="table-header_label">Completion Rate</span>
											</td>
										</tr>
									</table>
								</div>
							</td>
						</tr>
					</table>
				</div>
				<div *ngIf="!hasData">
					<div class="no-data-container ctv-no-data">
						<div class="no-data-header">
							<h5>Creatives</h5>
						</div>
						<div class="map-no-data">No Data to Display</div>
					</div>
				</div>
			</div>
			<div class="audioDisplayblock" id="audioDisplayblock" *ngIf="!showLoad && hasData">
				<div class="audio-container card-long-img">
					<div class="audio-icon-block" *ngIf="setDisplayProperties?.audioURL !== ''; else noAudioCreative">
						<svg width="107" height="87" viewBox="0 0 107 87" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M40.2516 4.10095C40.2516 2.36402 41.6595 0.956299 43.3962 0.956299C45.133 0.956299 46.5409 2.36402 46.5409 4.10095V83.3462C46.5409 85.0832 45.133 86.4909 43.3962 86.4909C41.6595 86.4909 40.2516 85.0832 40.2516 83.3462V4.10095Z"
								fill="#CF3339"
								class="primary-svg-fill"
							/>
							<path
								d="M30.1887 21.0821C30.1887 19.3452 31.5966 17.9374 33.3333 17.9374C35.0701 17.9374 36.478 19.3452 36.478 21.0821V66.3651C36.478 68.102 35.0701 69.5098 33.3333 69.5098C31.5966 69.5098 30.1887 68.102 30.1887 66.3651V21.0821Z"
								fill="#CF3339"
								class="primary-svg-fill"
							/>
							<path
								d="M63.522 22.9689C61.7852 22.9689 60.3774 24.3766 60.3774 26.1135V61.3337C60.3774 63.0706 61.7852 64.4783 63.522 64.4783C65.2588 64.4783 66.6667 63.0706 66.6667 61.3337V26.1135C66.6667 24.3766 65.2588 22.9689 63.522 22.9689Z"
								fill="#CF3339"
								class="primary-svg-fill"
							/>
							<path
								d="M50.3145 16.0506C50.3145 14.3137 51.7223 12.906 53.4591 12.906C55.1959 12.906 56.6038 14.3137 56.6038 16.0506V71.3965C56.6038 73.1335 55.1959 74.5412 53.4591 74.5412C51.7223 74.5412 50.3145 73.1335 50.3145 71.3965V16.0506Z"
								fill="#CF3339"
								class="primary-svg-fill"
							/>
							<path
								d="M83.6478 15.4217C81.911 15.4217 80.5031 16.8294 80.5031 18.5664V68.8808C80.5031 70.6178 81.911 72.0255 83.6478 72.0255C85.3846 72.0255 86.7924 70.6178 86.7924 68.8808V18.5664C86.7924 16.8294 85.3846 15.4217 83.6478 15.4217Z"
								fill="#CF3339"
								class="primary-svg-fill"
							/>
							<path
								d="M20.1258 29.8871C20.1258 28.1502 21.5337 26.7425 23.2704 26.7425C25.0072 26.7425 26.4151 28.1502 26.4151 29.8871V57.5601C26.4151 59.297 25.0072 60.7047 23.2704 60.7047C21.5337 60.7047 20.1258 59.297 20.1258 57.5601V29.8871Z"
								fill="#CF3339"
								class="primary-svg-fill"
							/>
							<path
								d="M73.5849 28.0003C71.8481 28.0003 70.4402 29.408 70.4402 31.145V56.3022C70.4402 58.0391 71.8481 59.4469 73.5849 59.4469C75.3217 59.4469 76.7296 58.0391 76.7296 56.3022V31.145C76.7296 29.408 75.3217 28.0003 73.5849 28.0003Z"
								fill="#CF3339"
								class="primary-svg-fill"
							/>
							<path
								d="M90.566 34.9186C90.566 33.1816 91.9739 31.7739 93.7107 31.7739C95.4475 31.7739 96.8553 33.1816 96.8553 34.9186V52.5286C96.8553 54.2656 95.4475 55.6733 93.7107 55.6733C91.9739 55.6733 90.566 54.2656 90.566 52.5286V34.9186Z"
								fill="#CF3339"
								class="primary-svg-fill"
							/>
							<path
								d="M13.2075 37.4343C11.4708 37.4343 10.0629 38.842 10.0629 40.5789V46.8682C10.0629 48.6052 11.4708 50.0129 13.2075 50.0129C14.9443 50.0129 16.3522 48.6052 16.3522 46.8682V40.5789C16.3522 38.842 14.9443 37.4343 13.2075 37.4343Z"
								fill="#CF3339"
								class="primary-svg-fill"
							/>
							<path
								d="M0 43.7236C0 41.9867 1.40788 40.5789 3.14465 40.5789C4.88143 40.5789 6.28931 41.9867 6.28931 43.7236C6.28931 45.4605 4.88143 46.8682 3.14465 46.8682C1.40788 46.8682 0 45.4605 0 43.7236Z"
								fill="#CF3339"
								class="primary-svg-fill"
							/>
							<path
								d="M103.774 40.5789C102.037 40.5789 100.629 41.9867 100.629 43.7236C100.629 45.4605 102.037 46.8682 103.774 46.8682C105.51 46.8682 106.918 45.4605 106.918 43.7236C106.918 41.9867 105.51 40.5789 103.774 40.5789Z"
								fill="#CF3339"
								class="primary-svg-fill"
							/>
						</svg>
						<div class="audio-file-block">
							<audio
								#audioTag
								id="preRollvideo"
								class="audioCreative"
								[src]="setDisplayProperties?.audioURL"
								[controls]="'controls'"
								[controlsList]="'nodownload'"
							></audio>
						</div>
					</div>
					<ng-template #noAudioCreative>
						<div class="icon-block no-audio-creative">NO DATA AVAILABLE</div>
					</ng-template>
				</div>
			</div>

			<div class="labels-position" [hidden]="showLoad">
				<div class="table-header_label metrics-labels" *ngIf="displayData && displayData.length > 0 && hasData">
					<table class="radio_creative_bottom_section">
						<tr>
							<td>
								<div class="radio-creative-table_svg_content">
									<div class="metrics">
										<span id="percent0" class="radio-creative-footer-content">Started</span>
										<span
											class="radio-creative-footer-content percent-value"
											*ngIf="setDisplayProperties.percent_value_25 != null"
										>
											<span class="rate-label-first">100%</span>
										</span>
									</div>
									<div class="line">
										<div
											(click)="circleAudioClickEvent(0)"
											[ngStyle]="{ 'background-color': defaultColor, color: primaryColor, opacity: '1.0' }"
											class="drawCircle"
											id="svg_0Percent"
										></div>
										<div class="verticalLine"></div>
									</div>
								</div>
								<div class="radio-creative-table_svg_content">
									<div class="metrics">
										<span id="percent25" class="radio-creative-footer-content">25% Completed</span>
										<span
											class="radio-creative-footer-content percent-value"
											*ngIf="setDisplayProperties.percent_value_25 != null"
										>
											<span>{{ setDisplayProperties.percent_rate_25 }}%</span>
											<span class="views-label">{{ setDisplayProperties.percent_value_25 | formatNumber }} Views</span>
										</span>
									</div>
									<div class="line">
										<div
											(click)="circleAudioClickEvent(25)"
											[ngStyle]="{ 'background-color': defaultColor, color: primaryColor, opacity: '1.0' }"
											class="drawCircle"
											id="svg_25Percent"
										></div>
										<div class="verticalLine"></div>
									</div>
								</div>
								<div class="radio-creative-table_svg_content">
									<div class="metrics">
										<span id="percent50" class="radio-creative-footer-content">50% Completed</span>
										<span
											class="radio-creative-footer-content percent-value"
											*ngIf="setDisplayProperties.percent_value_50 != null"
										>
											<span>{{ setDisplayProperties.percent_rate_50 }}%</span>
											<span class="views-label">{{ setDisplayProperties.percent_value_50 | formatNumber }} Views</span>
										</span>
									</div>
									<div class="line">
										<div
											(click)="circleAudioClickEvent(50)"
											[ngStyle]="{ 'background-color': defaultColor, color: primaryColor, opacity: '1.0' }"
											class="drawCircle"
											id="svg_50Percent"
										></div>
										<div class="verticalLine"></div>
									</div>
								</div>
								<div class="radio-creative-table_svg_content">
									<div class="metrics">
										<span id="percent75" class="radio-creative-footer-content">75% Completed</span>
										<span
											class="radio-creative-footer-content percent-value"
											*ngIf="setDisplayProperties.percent_value_75 != null"
										>
											<span>{{ setDisplayProperties.percent_rate_75 }}%</span>
											<span class="views-label">{{ setDisplayProperties.percent_value_75 | formatNumber }} Views</span>
										</span>
									</div>
									<div class="line">
										<div
											(click)="circleAudioClickEvent(75)"
											[ngStyle]="{ 'background-color': defaultColor, color: primaryColor, opacity: '1.0' }"
											class="drawCircle"
											id="svg_75Percent"
										></div>
										<div class="verticalLine"></div>
									</div>
								</div>
								<div class="radio-creative-table_svg_content">
									<div class="metrics">
										<span id="percent100" class="radio-creative-footer-content" style="margin-left: 1em"
											>100% Completed</span
										>
										<span
											class="radio-creative-footer-content percent-value"
											*ngIf="setDisplayProperties.percent_value_100 != null"
										>
											<span class="rate-label">{{ setDisplayProperties.percent_rate_100 }}%</span>
											<span class="views-label">{{ setDisplayProperties.percent_value_100 | formatNumber }} Views</span>
										</span>
									</div>
									<div class="line">
										<div
											(click)="circleAudioClickEvent(100)"
											[ngStyle]="{ 'background-color': defaultColor, color: primaryColor, opacity: '1.0' }"
											class="drawCircle"
											id="svg_100Percent"
										></div>
									</div>
								</div>
							</td>
						</tr>
					</table>
				</div>
				<div *ngIf="!hasData">
					<div class="no-data-container ctv-no-data">
						<div class="no-data-header">
							<h5>Creatives</h5>
						</div>
						<div class="map-no-data">No Data to Display</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
